import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-4 mx-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-mild" }, "\n          お仕事中に重大な事故などがあった際に、緊急連絡先に連絡されることがあります。\n        ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_PhoneNumberInputGroup = _resolveComponent("PhoneNumberInputGroup")!
  const _component_ValidationField = _resolveComponent("ValidationField")!
  const _component_FormSelectGroup = _resolveComponent("FormSelectGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      緊急連絡先の編集\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, {
        ref: "form",
        tag: "div",
        initialValues: _ctx.formValues
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_ValidationField, {
            label: "緊急連絡先(電話番号)",
            rules: { required: true, numeric: true, min: 10, max: 11 },
            name: "phoneNumber",
            modelValue: _ctx.phoneNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phoneNumber) = $event))
          }, {
            default: _withCtx((validationState) => [
              _createVNode(_component_PhoneNumberInputGroup, {
                modelValue: _ctx.phoneNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phoneNumber) = $event)),
                label: "緊急連絡先(電話番号)",
                placeholder: "緊急連絡先(電話番号)",
                class: "mb-3",
                "validation-state": validationState
              }, null, 8, ["modelValue", "validation-state"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createTextVNode(),
          _createVNode(_component_ValidationProvider, {
            name: "続柄",
            rules: "required",
            vid: "relationshipToWorker"
          }, {
            default: _withCtx((validationState) => [
              _createVNode(_component_FormSelectGroup, {
                modelValue: _ctx.relationshipToWorker,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.relationshipToWorker) = $event)),
                options: _ctx.relationshipToWorkerOptions,
                label: "続柄",
                firstOption: "続柄を選択",
                class: "mb-3",
                "validation-state": validationState
              }, null, 8, ["modelValue", "options", "validation-state"])
            ]),
            _: 1
          }),
          _createTextVNode(),
          _hoisted_2,
          _createTextVNode(),
          _createVNode(_component_AppButton, {
            block: "",
            onClick: ($event: any) => (handleSubmit(_ctx.onSubmit))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          設定する\n        ")
            ], undefined, true),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["initialValues"])
    ])
  ]))
}